// State argument is not application state, only the state this reducer is responsible for
function isLoadingByRedux(state = "", action) {
  switch (action.type) {
    case "SET_LOGIN":
      return action.value;
    default:
      return state;
  }
}

export default isLoadingByRedux;
